module.exports = "<div class=\"company-header client-header\">\n    <div class=\"navbar-header\">\n        <a class=\"navbar-brand\">\n            <img ng-show=\"companyImage\" class=\"company-image\" alt=\"Company image\" ng-src=\"{{companyImage}}\"/>\n        </a>\n    </div>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./web/js/components/navigation/company-navbar/companyNavbar.component.html
// module id = ./web/js/components/navigation/company-navbar/companyNavbar.component.html
// module chunks = 0